/**
 * Created by Josef Jurca on 17.7.2017.
 */
import {isValidResponse} from '../validators/assets';

/**
 * Returns server time.
 *
 * @returns {Promise} Get asset promise.
 */
export function getServerTime () {
    const url = this._baseUrl + this._endPoints.getServerTime;

    return this.read(
        {
            url: url
        })
        .then(response => {
            if (!isValidResponse(response)) {
                return 0;
            }

            // BE sends time in seconds.
            return response.result * 1000;
        });
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/servertime.js